// extracted by mini-css-extract-plugin
export default {"container":"container--J3Nw3","content":"content--HMII1","body":"body--qTlVr","description":"description--ZYC-W","link":"link--iD8vP button button-primary button-outline"};